// WhatsApp Business Configuration
export const WHATSAPP_NUMBER = '201221948907';
export const WHATSAPP_BASE_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

// Generate WhatsApp message based on language and activity (NO EMOJIS)
export const getWhatsAppMessage = (activityName, language = 'fr') => {
  if (language === 'en') {
    return `Hello,
I would like to book the activity: ${activityName}

Preferred date:
Number of people:
Hotel:

Thank you.`;
  }
  
  // French (default)
  return `Bonjour,
Je souhaite réserver l'activité : ${activityName}

Date souhaitée :
Nombre de personnes :
Hôtel :

Merci.`;
};

// Generate full WhatsApp URL with pre-filled message
export const getWhatsAppLink = (activityName, language = 'fr') => {
  const message = getWhatsAppMessage(activityName, language);
  return `${WHATSAPP_BASE_URL}?text=${encodeURIComponent(message)}`;
};

// Generic WhatsApp link (for general inquiries - NO EMOJIS)
export const getGenericWhatsAppLink = (language = 'fr') => {
  const message = language === 'en' 
    ? 'Hello, I would like information about excursions in Hurghada.'
    : 'Bonjour, je souhaite des informations sur les excursions à Hurghada.';
  return `${WHATSAPP_BASE_URL}?text=${encodeURIComponent(message)}`;
};
